(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wallie-social-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFeatured(scope) {
      var wrap = scope.querySelector('[data-wsp-video]');
      if (!wrap) return;
      var video = wrap.querySelector('[data-wsp-video-el]');
      var btn = wrap.querySelector('[data-wsp-play]');
      if (!video || !btn) return;

      function play() {
        video.play();
        wrap.classList.add('is-playing');
        if (!video.controls) video.controls = true;
      }

      function pause() {
        video.pause();
        wrap.classList.remove('is-playing');
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        play();
      });
      video.addEventListener('pause', function () { wrap.classList.remove('is-playing'); });
      video.addEventListener('play', function () { wrap.classList.add('is-playing'); });
    }

    function initReels(scope) {
      var stages = scope.querySelectorAll('[data-wsp-reel]');
      stages.forEach(function (stage) {
        var video = stage.querySelector('video');
        if (!video) return;
        stage.addEventListener('click', function () {
          if (video.paused) {
            video.play();
            stage.classList.add('is-playing');
            if (!video.controls) video.controls = true;
          } else {
            video.pause();
            stage.classList.remove('is-playing');
          }
        });
        video.addEventListener('pause', function () { stage.classList.remove('is-playing'); });
        video.addEventListener('play', function () { stage.classList.add('is-playing'); });
      });
    }

    function initPersonas(scope) {
      var strip = scope.querySelector('#wsp-persona-strip');
      var tagline = scope.querySelector('#wsp-persona-tagline');
      if (!strip || !tagline) return;
      var pills = Array.prototype.slice.call(strip.querySelectorAll('.wsp-persona-pill'));
      if (!pills.length) return;
      var idx = 0;
      var timer;
      var paused = false;

      function activate(i) {
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pills[i].classList.add('is-active');
        tagline.style.opacity = '0';
        setTimeout(function () {
          tagline.innerHTML = pills[i].getAttribute('data-tagline');
          tagline.style.opacity = '1';
        }, 200);
      }

      function start() {
        clearInterval(timer);
        timer = setInterval(function () {
          if (paused) return;
          idx = (idx + 1) % pills.length;
          activate(idx);
        }, 3500);
      }

      pills.forEach(function (pill, i) {
        pill.addEventListener('click', function () {
          idx = i;
          activate(i);
          paused = true;
          clearTimeout(window.__wspResume);
          window.__wspResume = setTimeout(function () { paused = false; }, 8000);
        });
      });

      start();
    }

    function init() {
      var section = document.querySelector('.wallie-social-proof');
      if (!section || section.dataset.wspInit === '1') return;
      section.dataset.wspInit = '1';
      initFeatured(section);
      initReels(section);
      initPersonas(section);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
